module.exports = __webpack_public_path__ + "assets/ic-coingecko.30308374.svg";